/* Small, independent enhancements. Shopify's native commerce code stays in control. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const init = (root = document) => {
    const motion = document.body.dataset.mvMotion !== 'false' && !reduced.matches;
    document.documentElement.classList.toggle('mv-reveal-ready', motion && !window.Shopify?.designMode && 'IntersectionObserver' in window);
    if (motion && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
      observer ||= new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { threshold: .07, rootMargin: '0px 0px 40px 0px' });
      root.querySelectorAll('[data-mv-reveal]').forEach(el => observer.observe(el));
    } else {
      root.querySelectorAll('[data-mv-reveal]').forEach(el => el.classList.add('is-visible'));
    }
    root.querySelectorAll('[data-mv-pause]').forEach(button => {
      if (button.dataset.mvBound) return;
      button.dataset.mvBound = 'true';
      button.addEventListener('click', () => {
        const paused = button.closest('[data-mv-marquee]').classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
    });
    root.querySelectorAll('[data-mv-menu]').forEach(menu => {
      if (menu.dataset.mvBound) return;
      menu.dataset.mvBound = 'true';
      menu.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
    });
  };
  document.addEventListener('click', e => document.querySelectorAll('[data-mv-menu][open],.mv-nav__dropdown[open]').forEach(menu => {
    if (!menu.contains(e.target)) menu.open = false;
  }));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.mv-nav__dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-mv-reveal]').forEach(el => observer?.unobserve(el)));
  document.addEventListener('shopify:block:select', e => {
    const bar = e.target.closest('[data-mv-marquee]');
    if (bar) bar.classList.add('is-paused');
    e.target.closest('[data-mv-reveal]')?.classList.add('is-visible');
  });
  reduced.addEventListener?.('change', () => init());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
